import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    RegionDetails:{},
}

const AllSubjectSlice = createSlice({
    name: "AllSubjectSlice",
    initialState,

    reducers: {
        AllSubjectData(state, action) {
            return {
                RegionDetails: action.payload.RegionDetails,
            };
        }
    }
})
export const { AllSubjectData } = AllSubjectSlice.actions;
export default AllSubjectSlice.reducer;